<template>
  <Modal ref="modal" v-bind="{ redirectOnClose: true }">
    <div class="modal color-red max-w-md mx-auto" slot-scope="{ closeModal }" @click.stop>
      <div class="modal__header">
        <h6 class="heading">
          {{ $t('deletePackageItem') | capitalize }}
        </h6>
      </div>
      <div class="modal__body space-y-8">
        <p class="text-center">
          {{ $t('deleteConfirmation') | capitalize }}
        </p>
        <div class="space-x-2 text-right">
          <button
            type="button"
            :disabled="deleting"
            class="btn style-link px-6"
            @click="closeModal"
          >
            {{ $t('cancel') | capitalize }}
          </button>
          <button :disabled="deleting" class="btn btn-danger px-6" @click="destroy">
            {{ $t('delete') | capitalize }}
          </button>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import { packageItemMethods } from '@/store/adminHelper';
import Modal from '@/components/Ui/Modal.vue';

export default {
  name: 'ModalDelete',
  components: {
    Modal,
  },
  props: {
    packageItemId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    deleting: false,
  }),
  methods: {
    ...packageItemMethods,
    destroy() {
      this.deleting = true;
      const { packageItemId } = this;
      this.deletePackageItem({ packageItemId })
        .then(() => {
          this.deleting = false;
          this.$refs.modal.closeModal();
        })
        .catch(() => {
          this.deleting = false;
        });
    },
  },
};
</script>
